<div *ngIf="isRegisterForm" class="login-modal-pop">
    <h5 class="continue-text">Continue with</h5>
    <div class="login-tabs">
        <ul class="nav nav-tabs mb-3" id="ex3" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link" (click)="showMobileNumberTab()" [class.active]="isMobileNumberTabActive"
                    aria-controls="ex1-tabs-1-login" aria-selected="true">Mobile Number</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" (click)="showEmailTab()" [class.active]="isEmailTabActive"
                    aria-controls="ex1-tabs-2-login" aria-selected="false">E-Mail</a>
            </li>
        </ul>
        <div class="sign-in-popup-dtls tab-content mt-4" id="ex1-content-login">
            <form [formGroup]="myForm" disabledAutocomplete (ngSubmit)="customerRegister(myForm)">
                <div class="form-floating login-via-email" *ngIf="isEmailTabActive">
                    <input type="email" formControlName="email" class="form-control" id="floatingInput"
                        placeholder="name@example.com" disabledAutocomplete>
                    <label for="floatingInput">Email ID *</label>
                    <div class="input-error" *ngIf="errorMessage">
                        <div><i class="fa-solid fa-circle-exclamation"></i> {{errorMessage}}</div>
                    </div>
                </div>
                <div class="form-floating login-via-number" *ngIf="isMobileNumberTabActive">
                    <input type="number" formControlName="mobile" class="form-control" id="countryCode" placeholder=" "
                        #countryCodeInput>
                    <label for="countryCode">Mobile Number *</label>
                    <div class="input-error" *ngIf="errorMessage">
                        <div><i class="fa-solid fa-circle-exclamation"></i> {{errorMessage}}</div>
                    </div>
                    <div class="custom-dropdown">
                        <input [value]="selectedCountryCode" class="selected-input-code-filed" autocomplete="off"
                            autocorrect="off" (click)="toggleDropdown($event)" autocapitalize="none" readonly
                            spellcheck="false" />
                        <div class="dropdown-content" [ngClass]="{ open: isOpen }">
                            <div class="search-via-input-code">
                                <input class="search-dropdown_dropdown_search" type="text" placeholder="Search"
                                    formControlName="searchText" (keyup)="search()" />
                            </div>
                            <div *ngFor="let code of countryCodes" (click)="toggleDropdown($event)">
                                <div (click)="toggleDropdown($event);countryCodeSelect(code,$event)">
                                    <span>{{ code.isd_code }}</span> ({{ code.country_en }})
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-floating mt-2">
                    <input type="password" formControlName="password" class="form-control floatingPassword"
                        id="floatingPassword" [type]="isPasswordVisible ? 'text' : 'password'" placeholder="Password"
                        required disabledAutocomplete>
                    <label for="floatingPassword">Password</label>
                    <div class="input-group-append">
                        <span class="input-group-text" (click)="togglePasswordVisibility()">
                            <i class="fas fa-eye show_eye" *ngIf="!isPasswordVisible"></i>
                            <i class="fas fa-eye-slash hide_eye" *ngIf="isPasswordVisible"></i>
                        </span>
                    </div>
                    <div class="input-error" *ngIf="errorMessagePassword">
                        <div><i class="fa-solid fa-circle-exclamation"></i> {{errorMessagePassword}}</div>
                    </div>
                </div>
                <div class="form-floating mt-2">
                    <div class="captcha-box">
                        <label for="captcha" class="captcha-label">Enter Captcha:</label>
                        <span>{{ captchaValue }}</span>
                        <div>
                            <input type="text" id="captcha" formControlName="captcha" placeholder="Enter Captcha Text"
                                autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false">
                            <button type="button" (click)="regenerateCaptcha()">
                                <i class="fas fa-refresh"></i>
                            </button>
                        </div>
                    </div>
                    <div class="input-error" *ngIf="errorMessageCaptch">
                        <div><i class="fa-solid fa-circle-exclamation"></i> {{errorMessageCaptch}}</div>
                    </div>
                </div>
                <p class="create-account-note">
                    <span>The password must be of minimum {{pwdMinLength}} character length, including </span>
                    <span *ngIf="pwdPsecialCharLength > 0">{{pwdPsecialCharLength}} Special Characters, </span>
                    <span *ngIf="pwdAlphaNumericharLength > 0">{{pwdAlphaNumericharLength}} Alphanumeric Characters, </span>
                    <span *ngIf="pwdUpperCaseLength > 0">{{pwdUpperCaseLength}} Uppercase Characters, </span>
                    <span *ngIf="pwdLowerCaseLength > 0">{{pwdLowerCaseLength}} Lowercase Characters, </span>
                    <span *ngIf="pwdNumericCharLength > 0">{{pwdNumericCharLength}} Numeric Characters</span>
                </p>
                <div class="sign-in-btn">
                    <button>Create Account</button>
                </div>
            </form>
        </div>
        <div class="other-login-opts">
            <span>OR</span>
        </div>
        <div class="social-media-logins mb-4">
            <ul class="mb-0">
                <li>
                    <a href="#"><img width="35" height="35" src="/assets/image/login/apple-id.png" alt=""></a>
                </li>
                <li>
                    <a href="#"><img width="35" height="35" src="/assets/image/login/google-id.png" alt=""></a>
                </li>
                <li>
                    <a href="#"><img width="35" height="35" src="/assets/image/login/twitter.png" alt=""></a>
                </li>
                <li>
                    <a href="#"><img width="35" height="35" src="/assets/image/login/instagram.png" alt=""></a>
                </li>
                <li>
                    <a href="#"><img width="35" height="35" src="/assets/image/login/facebook.png" alt=""></a>
                </li>
            </ul>
        </div>
        <span>have account? <a (click)="clickHandler()">Sign In</a></span>
    </div>
</div>

<div *ngIf="isOTPSend" class="otp-sent-main-div login-tabs">
    <div class="successfully-sent-otp">
      <img src="/assets/image/otp-send.gif" alt="">
      <h4>The activation code has been sent
        to the {{otpSentText}}</h4>
    </div>
  </div>

  <div class="enter-otp-inputs forgot-pass-filds login-tabs" *ngIf="enterOTP">
    <div class="otps-fileds">
      <form action="" disabledAutocomplete>
        <input #inputA type="text" maxlength="1" (input)="onInputChange(inputA)" autofocus />
        <input #inputB type="text" maxlength="1" (input)="onInputChange(inputB)" />
        <input #inputC type="text" maxlength="1" (input)="onInputChange(inputC)" />
        <input #inputD type="text" maxlength="1" (input)="onInputChange(inputD)" />
        <input #inputE type="text" maxlength="1" (input)="onInputChange(inputE)" />
        <input #inputF type="text" maxlength="1" (input)="onInputChange(inputF)" />
      </form>
      <p class="create-account-note mt-4">Please enter the OTP we have shared on <br>
        <b>{{otpSentOnText}}</b>
      </p>
      <div class="sign-in-btn">
        <button class="mt-0 mb-2" (click)="verifyOTP()">Continue</button>
      </div>
    </div>
  </div>
